<template>
  <section v-if="selectedConversation" id="main-section" ref="customerInfo" class="v2026-info">
    <div class="v2026-toolbar">
      <div class="v2026-toolbar__left">
        <button type="button"
                class="v2026-btn v2026-btn--danger"
                :disabled="selectedConversation.is_archived === 1"
                @click="confirmSetArchive()">ปิดเคส</button>

        <!-- version2026: master's ขยาย trigger, restored. Unconditional, exactly like master
             (CustomerInformation.vue:260 has no v-if). Disabled while the close-case dialog is up:
             both are BaseModals and both write document.body.style.overflow, so closing one would
             unlock the body under the other. -->
        <button v-if="useExpandChatModal"
                type="button"
                ref="expandBtn"
                class="v2026-btn--neutral"
                title="ขยายดูประวัติข้อความในแชท"
                aria-label="ขยายดูประวัติข้อความในแชท"
                aria-haspopup="dialog"
                :disabled="showCloseCaseConfirm"
                @click="showExpandChat = true">
          <i class="fas fa-expand-alt" aria-hidden="true"></i> ขยาย
        </button>

        <div class="v2026-pill v2026-pill--admin">
          <!-- Flag OFF only: under the flag the picker owns its own lead icon, the way the
               v2026 topic menu does. -->
          <span v-if="!useV2026AdminPicker" class="v2026-pill__lead" aria-hidden="true"
                :style="{ '-webkit-mask-image': 'url(' + pillIcons.admin + ')', 'mask-image': 'url(' + pillIcons.admin + ')' }"></span>
          <multiselect
            v-if="!useV2026AdminPicker"
            v-model="selectedConversation.admin"
            id="selectedAdmin"
            label="name"
            track-by="name"
            placeholder="แอดมินรับเคส"
            open-direction="bottom"
            ref="selectedItems"
            :options="admins"
            :searchable="true"
            :allow-empty="false"
            :deselectLabel="'ไม่สามารถลบแอดมินออกได้ ต้องปิดเคสเท่านั้น'"
            @input="setConversationAdmin">
            <template slot="option" slot-scope="props">
              <div class="option__desc d-inline-block">
                <img :src="props.option.profile_picture" width="40" class="rounded-circle img-circle-md">
                <span class="option__title">&nbsp;&nbsp;{{ props.option.name }}</span>
              </div>
            </template>
            <template slot="singleLabel" slot-scope="{ option }">
              <div class="d-flex justify-content-start align-items-center">
                <div class="mr-2">
                  <img :src="option.profile_picture" width="24" class="rounded-circle img-circle-sm">
                </div>
                <div>
                  <span class="text-small">{{ option.name.slice(0, 10) }}</span>
                </div>
              </div>
            </template>
          </multiselect>
          <!-- Keep this a v-else, never a second v-if: the two branches must be mutually
               exclusive so flag OFF cannot instantiate the new picker at all. -->
          <AdminPickerV2026 v-else
                            ref="adminPicker"
                            :admins="admins"
                            :selected="selectedConversation.admin"
                            :leadIcon="pillIcons.admin"
                            :conversationId="selectedConversation.id"
                            @select="onPickAdmin"
                            @open="closeSiblingMenus(null)" />
        </div>

        <div class="v2026-pill v2026-pill--topic" :title="selectedSystemTag.name">
          <section v-if="selectedConversation.customer_type === 'customer'">
            <b-dropdown v-if="!useV2026TopicMenu" size="sm" ref="dropdownSystemTag" variant="link" no-caret
                        toggle-class="v2026-pill__toggle">
              <template v-slot:button-content>
                <span class="v2026-pill__lead" aria-hidden="true"
                      :style="{ '-webkit-mask-image': 'url(' + pillIcons.topic + ')', 'mask-image': 'url(' + pillIcons.topic + ')' }"></span>
                <span class="v2026-pill__label">{{ selectedSystemTag.name }}</span>
                <i class="fas fa-chevron-down v2026-pill__chev"></i>
              </template>
              <b-card no-body>
                <b-card-body class="message-template-area text-small p-0">
                  <div v-for="(systemTag, index) in multiLevelTags" :key="index">
                    <div v-if="systemTag.id !== 0"
                         class="p-2"
                         :class="{'row-message-template' : systemTag.can_select}"
                         :style="`color: #222222`"
                         @click="(systemTag.can_select) ? addCustomerChatTopicTag(systemTag) : null">
                      {{ systemTag.name }}
                    </div>
                    <div v-for="(childTag, key) in systemTag.child_tags" :key="key">
                      <div class="pl-4 py-2 row-message-template"
                           :style="`color: ${childTag.color}`"
                           @click="addCustomerChatTopicTag(childTag)">
                        {{ childTag.name }}
                      </div>
                    </div>
                    <div class="dropdown-divider"></div>
                  </div>
                </b-card-body>
              </b-card>
              <b-dropdown-item-button class="text-center" @click="goToSystemTagSetting()">
                ตั้งค่าหัวข้อสนทนา
              </b-dropdown-item-button>
            </b-dropdown>
            <!-- ref is shared with the b-dropdown above ON PURPOSE: strict v-if/v-else means only
                 one is ever mounted, so the untouched this.$refs.dropdownSystemTag.hide(true) call
                 site works in both flag states. Never turn this v-else into a second v-if. -->
            <TopicMenuV2026 v-else
                            ref="dropdownSystemTag"
                            variant="systemTag"
                            :items="multiLevelTags"
                            :label="selectedSystemTag.name"
                            :leadIcon="pillIcons.topic"
                            :selectedId="selectedSystemTag.id"
                            :conversationId="selectedConversation.id"
                            :config="topicMenuVariants.systemTag"
                            @select="addCustomerChatTopicTag"
                            @footer="goToSystemTagSetting"
                            @open="closeSiblingMenus('dropdownSystemTag')" />
          </section>
          <section v-else-if="selectedConversation.customer_type === 'beneat_professional'">
            <b-dropdown v-if="!useV2026TopicMenu" size="sm" ref="dropdownChatTopic" variant="link" no-caret
                        toggle-class="v2026-pill__toggle">
              <template v-slot:button-content>
                <span class="v2026-pill__lead" aria-hidden="true"
                      :style="{ '-webkit-mask-image': 'url(' + pillIcons.topic + ')', 'mask-image': 'url(' + pillIcons.topic + ')' }"></span>
                <span class="v2026-pill__label">{{ selectedSystemTag.name }}</span>
                <i class="fas fa-chevron-down v2026-pill__chev"></i>
              </template>
              <b-card no-body>
                <b-card-body class="message-template-area text-small p-0">
                  <div v-for="(chatTopic, index) in chatTopics" :key="index">
                    <div class="p-2"
                         :class="{'row-message-template' : chatTopic.can_select}"
                         @click="(chatTopic.can_select) ? updateProfessionalChatTopic(chatTopic) : null">{{ chatTopic.name }}
                    </div>
                    <div v-for="(childChatTopic, key) in chatTopic.child_chat_topics" :key="key">
                      <div class="pl-4 py-2 row-message-template"
                           @click="updateProfessionalChatTopic(childChatTopic)">
                        {{ childChatTopic.name }}
                      </div>
                    </div>
                    <div class="dropdown-divider"></div>
                  </div>
                </b-card-body>
              </b-card>
            </b-dropdown>
            <!-- shared ref, same reason as the system-tag pair above -->
            <TopicMenuV2026 v-else
                            ref="dropdownChatTopic"
                            variant="chatTopic"
                            :items="chatTopics"
                            :label="selectedSystemTag.name"
                            :leadIcon="pillIcons.topic"
                            :selectedId="selectedSystemTag.id"
                            :conversationId="selectedConversation.id"
                            :config="topicMenuVariants.chatTopic"
                            @select="updateProfessionalChatTopic"
                            @open="closeSiblingMenus('dropdownChatTopic')" />
          </section>
        </div>

        <StatusIconPickerV2026 v-if="useStatusIconPicker && canPickStatusIcons"
                               ref="statusIconPicker"
                               :savedIds="statusIconSeedIds"
                               :conversationId="selectedConversation.id"
                               :customerType="selectedConversation.customer_type"
                               :submitting="siSubmitting"
                               @confirm="onStatusIconConfirm" />

        <!-- Shown only on the legacy-panel fallback rails: everywhere else the v2026 panel's tag section owns this. -->
        <div v-if="showToolbarTags" class="v2026-pill v2026-pill--topic">
          <b-dropdown v-if="!useV2026TopicMenu" size="sm" ref="dropdownTag" variant="link" no-caret
                      toggle-class="v2026-pill__toggle">
            <template v-slot:button-content>
              <span class="v2026-pill__lead" aria-hidden="true"
                    :style="{ '-webkit-mask-image': 'url(' + pillIcons.tag + ')', 'mask-image': 'url(' + pillIcons.tag + ')' }"></span>
              <span class="v2026-pill__label">เลือกแท็ก</span>
              <i class="fas fa-chevron-down v2026-pill__chev"></i>
            </template>
            <b-card no-body>
              <b-card-body class="message-template-area text-small p-0">
                <template v-for="(tag, index) in tags">
                  <div v-if="tag.id !== 0"
                       class="p-2 row-message-template"
                       :style="`color: ${tag.color}`"
                       @click="addConversationTag(tag)" :key="index">
                    <span class="d-inline-block pr-2"><i class="fas fa-tag"></i></span> {{ tag.name }}
                  </div>
                </template>
              </b-card-body>
            </b-card>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button class="text-center" @click="goToTagSetting()">
              ตั้งค่าแท็ก
            </b-dropdown-item-button>
          </b-dropdown>
          <!-- shared ref, same reason as the system-tag pair above -->
          <TopicMenuV2026 v-else
                          ref="dropdownTag"
                          variant="tag"
                          :items="tags"
                          label="เลือกแท็ก"
                          :leadIcon="pillIcons.tag"
                          :conversationId="selectedConversation.id"
                          :config="topicMenuVariants.tag"
                          @select="addConversationTag"
                          @footer="goToTagSetting"
                          @open="closeSiblingMenus('dropdownTag')" />
        </div>

        <!-- Shown only on the legacy-panel fallback rails, same reason as the picker above. -->
        <div class="v2026-tag-chips" v-if="selectedConversation.tags && showToolbarTags">
          <template v-for="(tag, index) in selectedConversation.tags">
            <span class="v2026-tag-chip" v-if="!tag.system"
                  :style="'background-color:' + tag.color" :key="index">
              {{ tag.name }}
              <span class="v2026-tag-chip__x" role="button"
                    @click="confirmDeleteConversationTag(tag)">
                <i class="fa fa-times"></i>
              </span>
            </span>
          </template>
        </div>
      </div>

      <div class="v2026-toolbar__right">
        <button type="button" class="v2026-btn--ghost"
                @click.prevent="$emit('clearConversation')">
          <i class="fas fa-times"></i> ปิดการสนทนา
        </button>
      </div>
    </div>

    <BaseModal :open="showCloseCaseConfirm" maxWidth="700px" :position="['top', 'center']" :modalStyle="['margin-top:10%']"
               @close="showCloseCaseConfirm = false">
      <div class="v2026-cc">
        <div class="v2026-cc__head">
          <span class="v2026-cc__title">ยืนยันการปิดเคส</span>
          <button type="button" class="v2026-cc__close" aria-label="ปิด"
                  @click="showCloseCaseConfirm = false">×</button>
        </div>
        <div class="v2026-cc__body">
          <span class="v2026-cc__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                    stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.75 11.75 11 14l4.25-4.25"
                    stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <p class="v2026-cc__msg">กรุณาตรวจสอบข้อมูลให้ชัดเจนก่อนกดปุ่มยืนยัน</p>
          <button type="button" class="v2026-cc__confirm" @click="doCloseCase">ยืนยัน</button>
        </div>
      </div>
    </BaseModal>

    <!-- version2026: master's ขยาย modal, rebuilt WITHOUT the shared-store hijack. Own fetch,
         own rows, own scroll — the pane behind is never touched, so closing needs no repair fetch. -->
    <ExpandChatModalV2026 v-if="useExpandChatModal"
                          :open="showExpandChat"
                          :conversationId="selectedConversation.id"
                          @close="closeExpandChat()" />

    <!-- version2026: the toolbar's own toast host — no MainPanelV2026 plumbing. Inert when unused. -->
    <BaseToast :open="toast.open" :variant="toast.variant" :title="toast.title" :message="toast.message"
               :autoHideDelay="toast.autoHideDelay" :icon="toast.icon"
               @close="toast.open = false" />
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
import AdminPickerV2026 from '@/components/coversation/AdminPickerV2026.vue'
import BaseModal from '@/components/coversation/BaseModal.vue'
import BaseToast from '@/components/coversation/BaseToast.vue'
import ExpandChatModalV2026 from '@/components/coversation/ExpandChatModalV2026.vue'
import StatusIconPickerV2026 from '@/components/coversation/StatusIconPickerV2026.vue'
import TopicMenuV2026, { TOPIC_MENU_VARIANTS } from '@/components/coversation/TopicMenuV2026.vue'
import { resolveStatusIcons } from '@/components/coversation/statusIconCatalog'

// Which rails get the status-icon pill: 'customer' and 'beneat_professional' (คุณแม่บ้าน). Opening one up
// later means this array AND STATUS_ICON_CUSTOMER_TYPES in chat-server/helpers/statusIconHelper.js,
// which is the copy that actually enforces it — this one only hides a button.
// The CARD is not gated by this, so nothing already saved can vanish if a type changes.
const STATUS_ICON_CUSTOMER_TYPES = ['customer', 'beneat_professional']

// TEMPORARY. These three rails still fall back to the legacy right panel, which has no
// TagsSectionV2026 — the toolbar pill and chip row are their ONLY tag add/remove affordance.
// Listed as the LEGACY rails on purpose, so a new or unknown customer_type defaults to the
// modern "tags live in the right panel" behaviour.
// DELETE this, showToolbarTags, and both blocks it gates once these three get a v2026 panel.
const TOOLBAR_TAG_FALLBACK_TYPES = [
  'professional_secondary',
  'recruitment_professional_secondary',
  'sales_product_customer'
]

// How long a just-confirmed set is trusted over the conversation row. The echo takes seconds, and
// the picker re-seeds from the saved value on every open — without this, confirming [a,b] then
// reopening a second later shows an EMPTY list, and ticking [c] silently wipes a and b.
const SI_COMMIT_GRACE_MS = 10000

// Default dwell for the status-icon toast.
const TOAST_MS = 2500

export default {
  name: 'CustomerInformationV2026',
  components: {
    AdminPickerV2026,
    BaseModal,
    BaseToast,
    ExpandChatModalV2026,
    StatusIconPickerV2026,
    TopicMenuV2026
  },
  props: {
    selectedConversation: Object
  },
  data () {
    return {
      pillIcons: {
        admin: require('@/assets/icons2026/admin.svg'),
        topic: require('@/assets/icons2026/topic.svg'),
        tag: require('@/assets/icons2026/tag.svg')
      },
      value: null,
      page: 0,
      options: ['list', 'of', 'options'],
      selectedSystemTag: {
        id: null,
        name: 'เลือกหัวข้อสนทนา',
        color: '#607D8B'
      },
      showCloseCaseConfirm: false,
      showExpandChat: false,
      // version2026: opt-in flag for the restored ขยาย control (master's expand modal). FALSE = the
      // toolbar exactly as it is today — no button, no modal instance, no new state. One boolean is
      // the whole rollback. Unlike master, the modal owns its own rows and never touches
      // message/messages, so opening it cannot blank the live chat pane behind it.
      useExpandChatModal: true,
      useStatusIconPicker: true,
      // version2026: opt-in flag for the v2026-themed bodies of the three toolbar dropdowns
      // (system tag / chat topic / tag). FALSE = the untouched b-dropdown blocks — byte-identical
      // rollback path. One flag for all three: they are one visual change shipped together.
      useV2026TopicMenu: true,
      // version2026: opt-in flag for the v2026 assign-admin picker. FALSE = the untouched
      // vue-multiselect block, byte-identical rollback path. The multiselect markup is kept
      // verbatim in the v-if branch; never delete it.
      useV2026AdminPicker: true,
      toast: { open: false, variant: 'success', title: '', message: '', autoHideDelay: TOAST_MS, icon: 'check' },
      siSubmitting: false,
      siLastCommitted: null
    }
  },
  computed: {
    topicMenuVariants () {
      return TOPIC_MENU_VARIANTS
    },
    statusIconIds () {
      const saved = this.selectedConversation && this.selectedConversation.status_icons
      return Array.isArray(saved) ? saved : []
    },
    statusIconSeedIds () {
      const committed = this.siLastCommitted
      if (committed && this.selectedConversation &&
        committed.convId === this.selectedConversation.id &&
        (Date.now() - committed.at) < SI_COMMIT_GRACE_MS) {
        return committed.ids
      }
      return this.statusIconIds
    },
    canPickStatusIcons () {
      return !!this.selectedConversation &&
        STATUS_ICON_CUSTOMER_TYPES.indexOf(this.selectedConversation.customer_type) !== -1
    },
    showToolbarTags () {
      return !!this.selectedConversation &&
        TOOLBAR_TAG_FALLBACK_TYPES.indexOf(this.selectedConversation.customer_type) !== -1
    },
    ...mapState('tag', ['tags', 'systemTags', 'multiLevelTags']),
    ...mapState('admin', ['admins', 'admin']),
    ...mapState('message', ['messages', 'performScroll']),
    ...mapState('conversation', ['conversation']),
    ...mapState('chatTopic', ['chatTopics']),
    ...mapState({
      menuType: state => state.menu.type
    })
  },
  watch: {
    performScroll () {
      if (this.performScroll && this.$refs.messageDisplay) {
        setTimeout(() => {
          if (this.page === 0) {
            this.$refs.messageDisplay.scrollTop = this.$refs.messageDisplay.scrollHeight
          } else {
            this.$refs.messageDisplay.scrollTop = this.$refs.messageDisplay.scrollHeight - this.contentHeight
          }
        }, 250)
      }
    },
    'selectedConversation': function (newVal, oldVal) {
      if (this.selectedConversation && this.selectedConversation.customer_type === 'customer') {
        if (this.selectedConversation.customer_chat_topic_tag) {
          this.selectedSystemTag.name = this.selectedConversation.customer_chat_topic_tag.name
          this.selectedSystemTag.id = this.selectedConversation.customer_chat_topic_tag.id
          this.selectedSystemTag.color = this.selectedConversation.customer_chat_topic_tag.color
        } else {
          this.selectedSystemTag.name = 'เลือกหัวข้อสนทนา'
          this.selectedSystemTag.id = null
          this.selectedSystemTag.color = '#607D8B'
        }
      } else if (this.selectedConversation && this.selectedConversation.customer_type === 'beneat_professional') {
        this.selectedSystemTag.name = 'เลือกหัวข้อสนทนา'
        this.selectedSystemTag.id = null
        this.selectedSystemTag.color = '#607D8B'
        if (this.selectedConversation.professional_chat_topic) {
          this.selectedSystemTag.name = this.selectedConversation.professional_chat_topic.name
        }
      }
    }
  },
  methods: {
    ...mapActions('menu', ['fetchMenuCount']),
    ...mapActions('chatTopic', ['fetchProfessionalChatTopics']),
    ...mapActions('conversation', ['fetchConversation']),
    ...mapActions('message', ['fetchMessages']),
    async onStatusIconConfirm (ids) {
      if (!this.selectedConversation) return
      const url = `/conversations/${this.selectedConversation.id}/status-icons`
      const submitData = {
        status_icons: ids,
        admin_id: this.admin ? this.admin.id : null
      }
      this.siSubmitting = true
      try {
        const { data } = await axios.post(url, submitData)
        const savedIds = data && data.conversation && Array.isArray(data.conversation.status_icons)
          ? data.conversation.status_icons
          : ids
        this.siLastCommitted = { convId: this.selectedConversation.id, ids: savedIds, at: Date.now() }
        if (this.$refs.statusIconPicker) this.$refs.statusIconPicker.close({ returnFocus: true })
        const labels = resolveStatusIcons(savedIds).map(item => item.label)
        this.showToast('success',
          labels.length ? 'บันทึก Icon สถานะแล้ว' : 'ล้าง Icon สถานะแล้ว',
          labels.join(', '))
      } catch (err) {
        const data = err.response && err.response.data
        const message = (data && data.message) || 'บันทึก Icon สถานะ ไม่สำเร็จ'
        if (this.$refs.statusIconPicker) this.$refs.statusIconPicker.showError(message)
      } finally {
        this.siSubmitting = false
      }
    },
    hasCustomerChatTopic (tags) {
      let result = false
      for (const tag of tags) {
        if (tag.system) {
          result = true
          break
        }
      }
      return result
    },
    displayChatTopic (chatTopic) {
      if (chatTopic.parent_id !== 0 && chatTopic.parent_chat) {
        return `${chatTopic.parent_chat.name} - ${chatTopic.name}`
      } else {
        return `${chatTopic.name}`
      }
    },
    confirmSetArchive () {
      if (this.selectedConversation.is_archived === 0) {
        this.showCloseCaseConfirm = true
      }
    },
    closeExpandChat () {
      this.showExpandChat = false
      this.$nextTick(() => {
        if (this.$refs.expandBtn && this.$refs.expandBtn.focus) this.$refs.expandBtn.focus()
      })
    },
    async doCloseCase () {
      this.showCloseCaseConfirm = false
      await this.setConversationArchive(false)
    },
    confirmDeleteConversationTag (tag) {
      this.$swal({
        text: 'คุณต้องการลบแท็กนี้ใช่หรือไม่',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.deleteConversationTag(tag)
        }
      })
    },
    showToast (variant, title, message, autoHideDelay = TOAST_MS, icon = 'check') {
      this.toast = { open: true, variant, title, message, autoHideDelay, icon }
    },
    // version2026: what v-model used to do on the flag-OFF multiselect, made explicit. The local
    // write MUST land before the PUT — the assign emits newMessage, not conversation, so the
    // authoritative admin only arrives a full round trip later (never, if the socket is down).
    onPickAdmin (admin) {
      if (!admin) {
        return
      }
      const current = this.selectedConversation.admin
      // the locked row: the picker never emits for it, this is the second line of defence
      if (current && String(current.id) === String(admin.id)) {
        return
      }
      this.selectedConversation.admin = admin
      this.setConversationAdmin(admin)
    },
    async setConversationAdmin (admin) {
      if (!admin) {
        return
      }
      const adminId = admin.id
      const url = `/conversations/${this.selectedConversation.id}`
      const submitData = {
        admin_id: adminId,
        assign_to_admin_id: adminId,
        assign_from_admin_id: this.admin.id,
        is_archived: 0
      }
      await axios.put(url, submitData)
    },
    async setConversationArchive () {
      const url = `/conversations/${this.selectedConversation.id}`
      const submitData = {
        admin_id: 0,
        admin_id_close: this.admin.id,
        is_archived: 1,
        beneat_chat_topic_id: null,
        customer_chat_topic_tag_id: null,
        close_case_lumen: 1,
        remind_at: null,
        active_menu: this.menuType
      }
      await axios.put(url, submitData)
      this.$emit('clearReminder')
      this.fetchMenuCount()
    },
    async addCustomerChatTopicTag (tag) {
      if (tag) {
        this.$refs.dropdownSystemTag.hide(true)
        await this.setConversationArchive()
        const submitData = {
          admin_id: this.admin.id
        }
        const url = `/conversations/${this.selectedConversation.id}/tags/${tag.id}`
        await axios.post(url, submitData)
        this.selectedSystemTag = tag
      }
    },
    async addConversationTag (tag) {
      this.$refs.dropdownTag.hide(true)
      const submitData = {
        admin_id: this.admin.id
      }
      const url = `/conversations/${this.selectedConversation.id}/tags/${tag.id}`
      await axios.post(url, submitData)
    },
    async deleteConversationTag (tag) {
      const url = `/conversations/${this.selectedConversation.id}/tags/${tag.id}`
      await axios.delete(url)
    },
    async handleMessageScroll ({
      target: { scrollTop, clientHeight, scrollHeight }
    }) {
      if (scrollTop === 0) {
        this.contentHeight = scrollHeight
        if (this.selectedConversation) {
          await this.loadMoreMessages(this.selectedConversation.id)
        }
      }
    },
    async loadFirstMessages (conversationId, own = undefined) {
      this.$store.commit('message/SET_MESSAGES', [])
      this.page = 0
      const params = {
        conversation_id: conversationId,
        page: this.page,
        own: own
      }
      await this.fetchMessages(params)
    },
    async loadMoreMessages (conversationId, own = undefined) {
      this.page = this.page + 1
      const params = {
        conversation_id: conversationId,
        page: this.page,
        own: own
      }
      await this.fetchMessages(params)
    },
    async updateProfessionalChatTopic (chatTopic) {
      this.$refs.dropdownChatTopic.hide(true)
      await this.setConversationArchive()
      const submitData = {
        admin_id: this.admin.id,
        conversation_id: this.selectedConversation.id,
        beneat_chat_topic: chatTopic,
        beneat_professional_id: this.selectedConversation.customer.beneat_professional_id
      }
      const url = '/beneat/update-chat-topic'
      await axios.post(url, submitData)
      this.selectedSystemTag.name = chatTopic.name
    },
    // Replaces b-dropdown's root-bus "opening one closes all others". OverlayCard's document
    // mousedown already covers the mouse path; this covers keyboard activation, where no
    // mousedown ever fires.
    closeSiblingMenus (except) {
      if (!this.useV2026TopicMenu) return
      const names = ['dropdownSystemTag', 'dropdownChatTopic', 'dropdownTag']
      names.forEach(name => {
        const menu = this.$refs[name]
        if (name !== except && menu && typeof menu.hide === 'function') menu.hide()
      })
    },
    goToTagSetting () {
      this.$router.push('/settings/tag')
    },
    goToSystemTagSetting () {
      this.$router.push('/settings/tag?system=1')
    }
  },
  mounted () {
    this.fetchProfessionalChatTopics()
  }
}
</script>

<style lang="scss" scoped>
.v2026-info {
  --v2026-red:            #FF2D55;
  --v2026-red-hover:      #E11D48;
  --v2026-teal:           #12A89F;
  --v2026-surface:        #FFFFFF;
  --v2026-surface-hover:  #E9ECF1;
  --v2026-border:         #E4E7EC;
  --v2026-border-thin:    #EAECF0;
  --v2026-pill-border:    #EBEDF0;
  --v2026-text:           #101828;
  --v2026-text-secondary: #667085;
  --v2026-text-muted:     #98A2B3;
  --v2026-icon:           #475467;
  --v2026-r-pill:   999px;
  --v2026-r-btn:    4px;
  --v2026-sp-1: 4px;
  --v2026-sp-2: 8px;
  --v2026-sp-3: 12px;
  --v2026-sp-4: 16px;
  --v2026-fs-ctrl: 13px;

  --v2026-ctrl-h: 36px;
}

.v2026-toolbar {
  display: flex;
  align-items: flex-start;

  flex-wrap: nowrap;
  min-width: 0;
  min-height: 48px;
  padding: var(--v2026-sp-2) var(--v2026-sp-4);
  background: var(--v2026-surface);
  border-bottom: 1px solid var(--v2026-border);
  gap: var(--v2026-sp-1);
}

.v2026-toolbar__left {
  display: flex;
  align-items: center;
  gap: var(--v2026-sp-1);

  flex-wrap: wrap;
  min-width: 0;
  flex: 1 1 auto;
}

.v2026-toolbar__right {
  display: flex;
  align-items: center;

  flex: 0 0 auto;
  align-self: flex-start;
  margin-left: auto;
}

.v2026-toolbar__left > .v2026-btn--danger {
  flex-shrink: 0;
}

.v2026-btn--danger {
  width: 58px;
  height: var(--v2026-ctrl-h);
  padding: 0;
  border: 0;
  flex-shrink: 0;
  border-radius: var(--v2026-r-btn);
  background: var(--v2026-red);
  color: #fff;
  font-size: var(--v2026-fs-ctrl);
  font-weight: 600;
  transition: background-color 150ms ease, opacity 150ms ease;

  &:hover:not(:disabled) {
    background: var(--v2026-red-hover);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

// version2026: deliberately the PILL treatment, not a button treatment. It must read as neutral
// so it cannot compete with ปิดเคส (solid red), and it matches the
// adjacent admin/topic pills so the toolbar keeps one silhouette.
.v2026-btn--neutral {
  height: var(--v2026-ctrl-h);
  padding: 0 var(--v2026-sp-2);
  border: 1px solid var(--v2026-pill-border);
  white-space: nowrap;
  flex-shrink: 0;
  border-radius: var(--v2026-r-btn);
  background: var(--v2026-surface);
  color: var(--v2026-text-secondary);
  font-size: var(--v2026-fs-ctrl);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: var(--v2026-sp-1);
  transition: background-color 150ms ease, color 150ms ease, opacity 150ms ease;

  &:hover:not(:disabled) {
    background: var(--v2026-surface-hover);
    color: var(--v2026-text);
  }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.v2026-btn--ghost {
  height: var(--v2026-ctrl-h);
  padding: 0 var(--v2026-sp-2);
  border: 0;
  white-space: nowrap;
  flex-shrink: 0;
  border-radius: var(--v2026-r-btn);
  background: var(--v2026-border-thin);
  color: var(--v2026-text);
  font-size: var(--v2026-fs-ctrl);
  display: inline-flex;
  align-items: center;
  gap: var(--v2026-sp-1);
  transition: background-color 150ms ease, color 150ms ease;

  &:hover {
    color: var(--v2026-text);
    background: var(--v2026-surface-hover);
  }
}

.v2026-pill {
  display: inline-flex;
  align-items: center;
  gap: var(--v2026-sp-1);
  height: var(--v2026-ctrl-h);
  padding: 0 var(--v2026-sp-2);
  border: 1px solid var(--v2026-pill-border);
  border-radius: 4px;
  background: var(--v2026-surface);
  color: var(--v2026-text-secondary);
  font-size: var(--v2026-fs-ctrl);
  flex-shrink: 0;
  transition: background-color 150ms ease;

  &:hover {
    background: var(--v2026-surface-hover);
  }
}

.v2026-pill__lead {
  width: 16px;
  height: 16px;
  display: inline-block;
  flex-shrink: 0;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-icon);
}

.v2026-pill__label {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--v2026-text-secondary);
}

.v2026-pill__chev {
  font-size: 10px;
  color: var(--v2026-text-muted);
}

.v2026-tag-chips {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--v2026-sp-1);
  min-width: 0;
}

.v2026-tag-chip {
  display: inline-flex;
  align-items: center;
  gap: var(--v2026-sp-1);
  height: var(--v2026-ctrl-h);
  padding: 0 var(--v2026-sp-2);
  border-radius: var(--v2026-r-pill);
  background: var(--v2026-teal);
  color: #fff;
  font-size: var(--v2026-fs-ctrl);
  white-space: nowrap;
}

.v2026-tag-chip__x {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 11px;
  opacity: 0.85;
  transition: opacity 150ms ease;

  &:hover {
    opacity: 1;
  }
}

.v2026-pill--topic {
  padding: 0;
  border: 0;
  background: transparent;

  &:hover {
    background: transparent;
  }

  ::v-deep .v2026-pill__toggle {
    display: inline-flex;
    align-items: center;
    gap: var(--v2026-sp-1);

    height: var(--v2026-ctrl-h);
    min-height: var(--v2026-ctrl-h);
    line-height: 1;
    padding: 0 var(--v2026-sp-2);
    border: 1px solid var(--v2026-pill-border);
    border-radius: 4px;
    background: var(--v2026-surface);
    color: var(--v2026-text-secondary);
    font-size: var(--v2026-fs-ctrl);
    text-decoration: none;
    box-shadow: none;

    &:hover, &:focus, &:active {
      background: var(--v2026-surface-hover);
      color: var(--v2026-text);
      box-shadow: none;
    }
  }
}

.v2026-pill--admin {
  padding-right: var(--v2026-sp-1);

  ::v-deep .multiselect {
    min-height: var(--v2026-ctrl-h);
    height: var(--v2026-ctrl-h);
    width: auto;
    display: inline-flex;
    align-items: center;
  }
  ::v-deep .multiselect__tags {
    min-height: 0;
    height: var(--v2026-ctrl-h);
    display: inline-flex;
    align-items: center;
    padding: 0 20px 0 2px;
    border: 0;
    background: transparent;
    font-size: var(--v2026-fs-ctrl);
  }
  ::v-deep .multiselect__single,
  ::v-deep .multiselect__placeholder,
  ::v-deep .multiselect__input {
    background: transparent;
    color: var(--v2026-text-secondary);
    font-size: var(--v2026-fs-ctrl);
    margin-bottom: 0;
    padding-top: 0;
    line-height: 1;
  }
  ::v-deep .multiselect__select {
    height: var(--v2026-ctrl-h);
  }
  ::v-deep .multiselect__select::before {
    border-color: var(--v2026-text-muted) transparent transparent;
  }
}

.v2026-cc__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #FFFFFF;
  border-bottom: 1px solid #EBEDF0;
  padding: 16px 24px;
}

.v2026-cc__title {
  font-size: 16px;
  font-weight: 600;
  color: #1F2937;
}

.v2026-cc__close {
  border: none;
  background: none;
  padding: 0;
  font-size: 20px;
  line-height: 1;
  color: #66696C;
  cursor: pointer;
}

.v2026-cc__body {
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
}

.v2026-cc__icon {
  width: 64px;
  height: 64px;
  color: #31C1D7;
}

.v2026-cc__icon svg {
  width: 100%;
  height: 100%;
  display: block;
}

.v2026-cc__msg {
  margin: 0;
  font-size: 14px;
  color: #66696C;
  line-height: 1.5;
}

.v2026-cc__confirm {
  min-width: 160px;
  height: 44px;
  background: #31C1D7;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 150ms ease;
}

.v2026-cc__confirm:hover {
  background: #2AAEC2;
}
</style>
